import axios from 'axios';
import {
  API_BILLING_STATISTICS_USER, API_BILLING_STATISTICS, API_BILLING_RADAR_INFO, API_GET_BILLING, API_BILLING_AREA,
  API_BILLING_USER_REQUESTS_REPORT, API_BILLING_REQUESTS, API_USER_BILLING_REQUESTS, API_USER_BILLING_AREA, API_BILLING_USER_RADAR_INFO,
  API_BILLING_GEOMAP_REQUEST_INFO, API_BILLING_GEOMAP_REQUEST_INFO_USER, API_BILLING_GEOMAP_STATISTICS, API_BILLING_GEOMAP_STATISTICS_USER,
  API_BILLING_ALL_USERS_REPORT, API_GET_BILLING_COUNT
} from '../../constants'
import RadarRequestInfo from '../../models/radars/RadarRequestInfo';
import AreaInfo from '../../models/billing/AreaInfo.js';
import WapiRadarStatistics from '../../models/billing/WapiRadarStatistics.js';
import WapiGeoMapStatistics from '../../models/geomap/WapiGeoMapStatistics.js';
import { wapiBillingPresetToGeoJson } from "../../helpers/wapihelpers.js";

import GeoMapRequestInfo from '../../models/geomap/GeoMapRequestInfo.js';
import { download } from '../../utils/common';

export default {
  state: {
    billing: [],
    billingArea: {},
    billingRequests: {},
    radarStatistics: [],
    radarInfo: {},
    geoMapStatistics: [],
    geoMapInfo: {},
    billingTypes: [
      {
        id: 0,
        name: 'Прогноз'
      },
      {
        id: 1,
        name: 'Реанализ'
      },
      {
        id: 2,
        name: 'Радар'
      },
      {
        id: 3,
        name: 'Карты'
      },
    ]
  },
  mutations: {
    SET_BILLING: (state, payload) => {
      state.billing = payload;
    },
    SET_BILLING_AREA: (state, payload) => {
      state.billingArea = payload;
    },
    SET_BILLING_REQUESTS: (state, payload) => {
      state.billingRequests = payload;
    },
    SET_BILLING_RADAR_STATISTICS: (state, payload) => {
      state.radarStatistics = payload;
    },
    SET_RADAR_INFO: (state, payload) => {
      state.radarInfo = payload;
    },
    SET_BILLING_GEOMAP_STATISTICS: (state, payload) => {
      state.geoMapStatistics = payload;
    },
    SET_BILLING_GEOMAP_INFO: (state, payload) => {
      state.geoMapInfo = payload;
    },
  },
  actions: {
    FETCH_BILLING: async (context, payload) => {
      try {
        const url = `${API_GET_BILLING}/${payload.userId}?from=${payload.from}&to=${payload.to}&take=${payload.take}&skip=${payload.skip}&dataType=${payload.data_type}`;
        const response = await axios.get(url);
        const billing = response.data.result.data;
        let i = 0;
        billing.forEach(x => {
          x['id'] = i++;
          if (x.billing_preset) {
            x.billing_preset['geoJson'] = wapiBillingPresetToGeoJson(x.billing_preset, x.user_id[1, 0]);
          }
        });
        context.commit('SET_BILLING', billing);
      } catch {
        context.commit('SET_BILLING', []);
      }
    },
    FETCH_BILLING_COUNT: async (context, payload) => {
      try {
        const url = `${API_GET_BILLING_COUNT(payload.userId, payload.from, payload.to, payload.data_type)}`;
        const response = await axios.get(url);
        const result = response.data.result;
        return result;
      } catch {
        context.commit('SET_BILLING', []);
      }
    },
    FETCH_BILLING_AREA: async (context, payload) => {
      try {
        const url = `${API_BILLING_AREA}/${payload}`
        let billingResponse = await axios.get(url);
        const billingArea = billingResponse.data.result;

        context.commit('SET_BILLING_AREA', billingArea);
      } catch {
        const area = new AreaInfo();
        context.commit('SET_BILLING_AREA', area);
        return area;
      }
    },
    FETCH_USER_BILLING_AREA: async () => {
      try {
        const url = `${API_USER_BILLING_AREA}`
        let billingResponse = await axios.get(url);
        const billingArea = billingResponse.data.result;
        return billingArea;
      }
      catch {
        const area = new AreaInfo();
        return area;
      }
    },
    FETCH_BILLING_REQUESTS: async (context, payload) => {
      try {
        const url = `${API_BILLING_REQUESTS}/${payload}`;
        let billingResponse = await axios.get(url);
        const billingRequests = billingResponse.data.result;
        context.commit('SET_BILLING_REQUESTS', billingRequests);
      } catch {
        const requests = new RadarRequestInfo();
        context.commit('SET_BILLING_REQUESTS', requests);
        return requests;
      }
    },
    FETCH_USER_BILLING_REQUESTS: async (context) => {
      try {
        const url = `${API_USER_BILLING_REQUESTS}`;
        let billingResponse = await axios.get(url);
        const billingRequests = billingResponse.data.result;
        context.commit('SET_BILLING_REQUESTS', billingRequests);
      } catch {
        const requests = new RadarRequestInfo();
        context.commit('SET_BILLING_REQUESTS', requests);
        return requests;
      }
    },
    BILLING_USER_REQUESTS_REPORT: async (context, payload) => {
      try {
        const timezoneOffset = new Date().getTimezoneOffset();
        const url = `${API_BILLING_USER_REQUESTS_REPORT(payload.userId, payload.territory, payload.from, payload.to, timezoneOffset)}`;
        const response = await axios.get(url,
          {
            responseType: 'blob',
            headers: {
              'Authorization': `Bearer ${context.getters.TOKEN}`
            },
            baseURL: ''
          }
        );
        download(response);
      }
      catch {
        return null;
      }
    },
    BILLING_ALL_USER_REPORT: async (context, payload) => {
      try {
        const timezoneOffset = new Date().getTimezoneOffset();
        const url = `${API_BILLING_ALL_USERS_REPORT(payload.from, payload.to, timezoneOffset)}`;
        const response = await axios.get(url, { responseType: "blob", baseURL: '' });
        download(response);
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_RADAR_INFO: async (context) => {
      try {
        const url = `${API_BILLING_RADAR_INFO}`;
        let billingResponse = await axios.get(url);
        const data = billingResponse.data.result;
        context.commit('SET_RADAR_INFO', data);
        return data;
      }
      catch {
        context.commit('SET_RADAR_INFO', null);
        return null;
      }
    },
    FETCH_USER_RADAR_INFO: async (context, payload) => {
      try {
        const url = `${API_BILLING_USER_RADAR_INFO(payload)}`;
        let billingResponse = await axios.get(url);
        const data = billingResponse.data.result;
        context.commit('SET_RADAR_INFO', data);
        return data;
      }
      catch {
        const info = new RadarRequestInfo();
        context.commit('SET_RADAR_INFO', new RadarRequestInfo());
        return info;
      }
    },
    FETCH_RADAR_STATISTICS: async (context, payload) => {
      try {
        const url = `${API_BILLING_STATISTICS(payload.from, payload.to)}`;
        let response = await axios.get(url);
        const data = response.data.result;

        context.commit('SET_BILLING_RADAR_STATISTICS', data);
        return data;
      } catch {
        const wapiRadarStatistics = new WapiRadarStatistics();
        context.commit('SET_BILLING_RADAR_STATISTICS', wapiRadarStatistics);
        return wapiRadarStatistics;
      }
    },
    FETCH_RADAR_STATISTICS_USER: async (context, payload) => {
      try {
        const url = `${API_BILLING_STATISTICS_USER(payload.userId, payload.from, payload.to)}`
        let response = await axios.get(url);
        const data = response.data.result;

        context.commit('SET_BILLING_RADAR_STATISTICS', data);
        return data;
      } catch {
        const wapiRadarStatistics = new WapiRadarStatistics();
        context.commit('SET_BILLING_RADAR_STATISTICS', wapiRadarStatistics);
        return wapiRadarStatistics;
      }
    },
    FETCH_BILLING_GEOMAP_INFO: async (context) => {
      try {
        const url = `${API_BILLING_GEOMAP_REQUEST_INFO}`;
        const response = await axios.get(url);
        const data = response.data.result;
        context.commit('SET_BILLING_GEOMAP_INFO', data);
        return data;
      }
      catch {
        context.commit('SET_BILLING_GEOMAP_INFO', null);
        return null;
      }
    },
    FETCH_BILLING_GEOMAP_INFO_USER: async (context, payload) => {
      try {
        const url = `${API_BILLING_GEOMAP_REQUEST_INFO_USER(payload)}`;
        const response = await axios.get(url);
        const data = response.data.result;
        context.commit('SET_BILLING_GEOMAP_INFO', data);
        return data;
      }
      catch {
        const info = new GeoMapRequestInfo();
        context.commit('SET_GEOMAP_INFO', new GeoMapRequestInfo());
        return info;
      }
    },
    FETCH_GEOMAP_STATISTICS: async (context, payload) => {
      try {
        const url = `${API_BILLING_GEOMAP_STATISTICS(payload.from, payload.to)}`;
        const response = await axios.get(url);
        const data = response.data.result;

        context.commit('SET_BILLING_GEOMAP_STATISTICS', data);
        return data;
      } catch {
        const wapiGeoMapStatistics = new WapiGeoMapStatistics();
        context.commit('SET_BILLING_GEOMAP_STATISTICS', wapiGeoMapStatistics);
        return wapiGeoMapStatistics;
      }
    },
    FETCH_GEOMAP_STATISTICS_USER: async (context, payload) => {
      try {
        const url = `${API_BILLING_GEOMAP_STATISTICS_USER(payload.userId, payload.from, payload.to)}`
        const response = await axios.get(url);
        const data = response.data.result;

        context.commit('SET_BILLING_GEOMAP_STATISTICS', data);
        return data;
      } catch {
        const wapiGeoMapStatistics = new WapiGeoMapStatistics();
        context.commit('SET_BILLING_GEOMAP_STATISTICS', wapiGeoMapStatistics);
        return wapiGeoMapStatistics;
      }
    },
  },
  getters: {
    BILLING: state => {
      return state.billing;
    },
    BILLING_REQUESTS: state => {
      return state.billingRequests;
    },
    BILLING_AREA: state => {
      return state.billingArea;
    },
    RADAR_INFO: state => {
      return state.radarInfo;
    },
    BILLING_TYPES: state => {
      return state.billingTypes;
    },
    RADAR_STATISTICS: state => {
      return state.radarStatistics;
    },
    GEOMAP_STATISTICS: state => {
      return state.geoMapStatistics;
    },
    GEOMAP_INFO: state => {
      return state.geoMapInfo;
    },
  }
}